import { style } from '@do/walrus';
import styled from 'styled-components';

const NewTitle = styled.h3`
  margin-bottom: ${style.vars.whitespace.small};
`;

export default NewTitle;
